import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from './reducers/rootReducers';

const cartItemsFromStorage = localStorage.getItem('shopkpr_cartItems')
    ? JSON.parse(localStorage.getItem('shopkpr_cartItems'))
    : [];

const middleware = [thunk];
const initial = {
    cart: {
        cartItems: cartItemsFromStorage,
    },
};

export const store = createStore(
    reducers,
    initial,
    composeWithDevTools(applyMiddleware(...middleware))
);
